import { Component, Input, ViewEncapsulation } from '@angular/core';

import { EmailButtonComponent } from '../../components/email-button/email-button.component';
import { EmailLayoutComponent } from '../../components/email-layout/email-layout.component';
import { EmailLinkComponent } from '../../components/email-link/email-link.component';
import { EmailMarginComponent } from '../../components/email-margin/email-margin.component';
import { EmailMessageHeaderComponent } from '../../components/email-message-header/email-message-header.component';
import { EmailTellentLogoComponent } from '../../components/email-tellent-logo/email-tellent-logo.component';
import { EmailTextComponent } from '../../components/email-text/email-text.component';
import { TellentProductsFooterComponent } from '../../components/tellent-products-footer/tellent-products-footer.component';
import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';
import { WrappedValue } from '../../mailgun/wrap-value';

@Component({
  standalone: true,
  styleUrls: [
    '../../global-styles.less',
    './tellent-account-recovery-request-started.component.less',
  ],
  templateUrl: './tellent-account-recovery-request-started.component.html',
  imports: [
    EmailMarginComponent,
    EmailLayoutComponent,
    EmailMessageHeaderComponent,
    EmailTextComponent,
    EmailButtonComponent,
    EmailLinkComponent,
    EmailTellentLogoComponent,
    TellentProductsFooterComponent,
  ],
  hostDirectives: [SsrMarkToUnwrapDirective],
  encapsulation: ViewEncapsulation.None,
})
export class TellentAccountRecoveryRequestStartedTemplateComponent {
  @Input({ required: true })
  public data: WrappedValue<TellentAccountRecoveryRequestStartedTemplateData>;
}

export type TellentAccountRecoveryRequestStartedTemplateData = {
  title: string;
  p1: string;
  p2_html: string;
  p3_html: string;
  stop_label: string;
  stop_url: string;
  p4: string;
  p5_html: string;
  footer: {
    text: string;
    label: string;
    href: string;
  };
};

export const TellentAccountRecoveryRequestStartedTemplateMocks: TellentAccountRecoveryRequestStartedTemplateData[] =
  [
    {
      title: 'Account recovery',
      p1: 'We have received a request to recover access to your account.',
      p2_html: '<b>Request time:</b> %{date}',
      p3_html: '<b>IP Address:</b> %{ip_address}',
      stop_label: 'Stop recovery now',
      stop_url: 'http://recruitee.com',
      p4: 'Please note that this can take us from 48 to 72 hours. We’ll send you an email with a link to recover access. Thank you for being patient.',
      p5_html:
        "It this wasn’t you, please <b>stop the recovery process</b> and <a href='%{url}'>contact our support</a>.",
      footer: {
        text: 'Need help?',
        href: 'support@tellent.com',
        label: 'Contact us',
      },
    },
  ];
